import React from "react";
import { Box, Stack, TextField, InputAdornment, Typography, Checkbox, FormControlLabel } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";
import ByzMuiSearchButton from "src/components/core-components/mui/buttons/ByzMuiSearchButton";
import ByzMuiCloseButton from "src/components/core-components/mui/buttons/ByzMuiCloseButton";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import { useTranslate } from "src/locales";
import ColorsHeader from "./colorsheader";

interface HeaderProps {
  onClose: () => void;
}

const Header: React.FC<HeaderProps> = ({ onClose }) => {
  const { t } = useTranslate();

  return (
    <Box sx={{ mb: 3 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
          flexWrap: "wrap",
          gap: 1,
        }}
      >
        <Typography
          variant="h4"
          fontWeight={500}
          sx={{ fontSize: { xs: "1.2rem", sm: "1.5rem" } }}
        >
          {t("menus.add-stock")}
        </Typography>
        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
          <ByzMuiCloseButton onClick={onClose} />
        </Box>
      </Box>

      <Stack direction="row" spacing={1.5} alignItems="flex-start">
        <TextField
          size="small"
          placeholder={t("menus.stock-search-placeholder")}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" >
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end" >
                <FilterListIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
          sx={{
            width: 285,
            "& .MuiOutlinedInput-root": {
              height: 48,
              backgroundColor: "#f4f5f7",
              "& fieldset": {
                border: "none",
              },
              "&:hover fieldset": {
                border: "none",
              },
              "&.Mui-focused fieldset": {
                border: "none",
              },
            },
          }}
        />
        <Box sx={{ width: 30, height: 30, padding: "1px", scale: "0.8" }}>
          <ByzMuiSearchButton />
        </Box>
        <Box
          sx={{
            width: "1px",
            height: "50px",
            bgcolor: "divider",
            mx: 1.5,
            mt: 0.25,
          }}
        />
        <ByzMuiTextField
          sx={{ minWidth: 220, mt: 0.75 }}
          size="small"
          label={t("menus.stock-product-barcode-label")}
          variant="outlined"
        />

        <Box
          sx={{
            width: "1px",
            height: "50px",
            bgcolor: "divider",
            ml: "15px",
            mr: "15px",
            mt: 0.25,
            flexShrink: 0,
          }}
        />

        <Box sx={{ display: "flex", alignItems: "center", gap: 2, mt: 0.25 }}>
          <FormControlLabel
            control={<Checkbox size="small" />}
            label={
              <Typography
                sx={{
                  position: "relative",
                  fontSize: "12px",
                  fontFamily: "Poppins, sans-serif",
                  color: "#3b3c3f",
                  textAlign: "left",
                }}
              >
                {t("menus.stock-checkbox-available")}
              </Typography>
            }
          />
          <FormControlLabel
            control={<Checkbox size="small" />}
            label={
              <Typography
                sx={{
                  position: "relative",
                  fontSize: "12px",
                  fontFamily: "Poppins, sans-serif",
                  color: "#3b3c3f",
                  textAlign: "left",
                }}
              >
                {t("menus.stock-checkbox-upper-stock")}
              </Typography>
            }
          />
          <FormControlLabel
            control={<Checkbox size="small" />}
            label={
              <Typography
                sx={{
                  position: "relative",
                  fontSize: "12px",
                  fontFamily: "Poppins, sans-serif",
                  color: "#3b3c3f",
                  textAlign: "left",
                }}
              >
                {t("menus.stock-all")}
              </Typography>
            }
          />
        </Box>
      </Stack>

      <Box sx={{ mt: "21px" }}>
        <ColorsHeader />
      </Box>
    </Box>
  );
};

export default Header;
